export default __webpack_public_path__ + "static/media/startup.9ff115da.svg";